import { makeStyles } from "tss-react/mui";

export const useStyles = makeStyles()((theme) => ({
    buttonBox: {
        display: "flex",
        justifyContent: "flex-end",
        alignItems: "center",
        gap: theme.spacing(1),
        height: 50,
    },
    collapseBtn: {
        "&:focus": {
            outline: "none",
        },
    },
    collapsePropertyTitle: {
        fontWeight: "bold",
    },
    overflow: {
        overflow: "hidden",
        textOverflow: "ellipsis",
    },
}));
